<script lang="ts" setup>
import { useCtaComponent } from '@monogrid/vue-boost'
import { PropType, useAttrs, useSlots } from 'vue'

import { SizeOptions } from '@/types'

defineProps({
  active: { type: Boolean, default: false },
  size: { type: String as PropType<SizeOptions>, default: 'xs' }
})

const { bindings, component } = useCtaComponent({
  attrs: useAttrs(),
  emit: undefined,
  slots: useSlots(),
  expose: undefined
})
</script>

<template>
  <component
    :is="component"
    v-bind="bindings"
    :class="[{ active }, size]"
    :target="bindings.href ? '_blank' : undefined"
    class="app-button-text inline-flex items-center justify-center relative whitespace-nowrap cursor-pointer"
    tabindex="0"
  >
    <span class="relative tracking-wide"><slot /></span>
  </component>
</template>

<style lang="scss" scoped>
.app-button-text {
  font-weight: 400;
  line-height: 110%;
  transition: opacity $default-duration ease;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.4;
  }

  &.xs {
    font-size: rem(16px);
  }

  &.sm {
    font-size: rem(18px);
  }

  &.md {
    font-size: rem(24px);
  }

  &.lg {
    font-size: rem(34px);
  }
}

span {
  &::after {
    position: absolute;
    top: 110%;
    left: 0;
    width: 100%;
    height: rem(1px);
    background-color: currentColor;
    content: "";
    transform: scaleX(0);
    transform-origin: center;
    transition: transform $default-duration ease;

    @include hover {
      .app-button-text:hover & {
        transform: scaleX(0.5);
      }
    }

    .app-button-text.active & {
      transform: scaleX(0.5);
    }
  }
}
</style>
